// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iWiIfNhpboTKuhmoFsEN {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1.3438rem;
  right: 1.3438rem;
  width: 32px;
  height: 32px;
}
.iWiIfNhpboTKuhmoFsEN:hover {
  border-radius: 50%;
  cursor: pointer;
  background-color: rgba(50, 50, 50, 0.6);
  transition: all 0.3s;
}
.iWiIfNhpboTKuhmoFsEN:active {
  background-color: #282828;
}
.iWiIfNhpboTKuhmoFsEN:active span {
  background-color: #b6b6b6;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Modal/Modal.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAAF;AACE;EACE,kBAAA;EACA,eAAA;EACA,uCAAA;EACA,oBAAA;AACJ;AACE;EACE,yBC6BQ;AD5BZ;AAAI;EACE,yBCGU;ADDhB","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"close": `iWiIfNhpboTKuhmoFsEN`
};
export default ___CSS_LOADER_EXPORT___;
